'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.156 11.167c-.015.272-.023.55-.023.832h2.064c0-.285.009-.563.025-.832h6.947l.836-1.716H9.462c.106-.46.244-.885.414-1.278.453-1.046 1.07-1.839 1.849-2.376a4.528 4.528 0 0 1 2.631-.807c.505 0 .98.066 1.428.198.453.131.874.311 1.264.54.23.133.449.275.657.428L19 4.716a6.043 6.043 0 0 0-2.116-1.287A7.524 7.524 0 0 0 14.356 3c-1.41 0-2.66.366-3.75 1.098-1.083.732-1.934 1.773-2.553 3.123a9.784 9.784 0 0 0-.694 2.23H5.615L5 11.167h2.156ZM7.156 12.833A15.719 15.719 0 0 1 7.133 12h2.064c0 .285.009.563.025.832h7.783l-.831 1.716H9.462c.106.46.244.885.414 1.278.453 1.046 1.07 1.839 1.849 2.376.78.538 1.657.807 2.631.807.505 0 .98-.066 1.428-.198a5.538 5.538 0 0 0 1.264-.54c.23-.133.449-.275.657-.428L19 19.284a6.043 6.043 0 0 1-2.116 1.287 7.526 7.526 0 0 1-2.528.429c-1.41 0-2.66-.366-3.75-1.098-1.083-.732-1.934-1.773-2.553-3.123a9.785 9.785 0 0 1-.694-2.23H5l.62-1.716h1.536Z"
  })));
});
var Euro = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Euro = Euro;